import React, { useEffect, useState } from 'react';
import '../Property/property.css';
import axios from 'axios';
import Footer from '../Footer/Footer';

const Property = () => {
  const [type, setType] = useState([]); 
  const [properties, setProperties] = useState([]); 

  useEffect(() => {
    getType();
    getProperty(); 
  }, []);

  const getType = () => {
    axios.get('https://pkrealestateapi.onrender.com/type/latest-type/10')
      .then(res => {
        console.log('Property Types:', res.data.Type); 
        setType(res.data.Type || []); 
      })
      .catch(err => {
        console.error('Error fetching property types:', err);
      });
  };

  const getProperty = () => { 
    axios.get('https://pkrealestateapi.onrender.com/property')
      .then(res => {
        console.log('Latest Properties:', res.data.properties); 
        setProperties(res.data.properties || []); 
      })
      .catch(err => {
        console.error('Error fetching properties:', err);
      });
  };

  const getPropertyByTyp = (typ) => { 
    axios.get(`https://pkrealestateapi.onrender.com/property/type/${typ}`)
      .then(res => {
        console.log('API Response:', res.data); 
        if (res.data && res.data.properties) {
          console.log('Filtered Properties:', res.data.properties);
          setProperties(res.data.properties || []);
        } else {
          console.error('No properties found for this type.');
          setProperties([]);
        }
      })
      .catch(err => {
        console.error('Error fetching properties by type:', err);
      });
  };

  return (
    <div>
      <div className='main-container'>
        <div className='Pproperties-container'>
          {properties.length > 0 ? properties.map(data => (
            <div className='Pproperty-card fade-in' key={data._id}>
              <img className='p-image' alt='property' src={data.imageUrl} />
              <h2 className='p-name'>{data.name}</h2>
              <p className='p-type'>Type: {data.type}</p>
              <p className='p-location'>Location: {data.location}</p>
              <p className='p-price'>Price: ₹{new Intl.NumberFormat('en-IN').format(data.price)}</p>
              <p className='p-description'>Description: {data.description}</p>

            </div>
          )) : <p>No properties available.</p>}
        </div>

        <div className='Ttype-container'>
          <h3>All Property Types</h3>
          <div>
            {type.map(data => (
              <div className='t-container' key={data._id}>
                <button 
                  className='t-button' 
                  onClick={() => getPropertyByTyp(data.name)}
                >
                  {data.name}
                </button>
              </div>
            ))}
          </div>

          
          <button className='all-properties-button' onClick={getProperty}>
            All Properties
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Property;